module.exports = __webpack_public_path__ + "static/media/pair-logo-animation.27db5e9a.mp4";